/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import qs from 'query-string';
import Table from '../../../Common/Table';
import NotificationService from '../../../../Service/NotificationService';
import PageHeader from '../../../Common/PageHeader';
import { Link, withRouter } from 'react-router-dom';
import Loader from '../../../../Component/Common/Loader';
import Filter from '../../../Customers/Filter';
import Swal from 'sweetalert2';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import { hot } from 'react-hot-loader';

class EmailTemplates extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false,
			_customFilterQuery: ''
		};
	}

	getAllEmailTemplates = async queryUrl => {
		return NotificationService.getAllEmailTemplates(this.props.match.params.id, queryUrl);
	};

	searchQuery = (query, changePage = true) => {
		const queryItems = qs.parse(window.location.search);
		queryItems.globalSearch = query;
		queryItems.page = changePage ? 0 : queryItems.page;
		this.props.history.push({
			search: qs.stringify(queryItems)
		});
		const queryUrl = `filter=${query}`;
		this.setState({
			_customFilterQuery: queryUrl
		});
	};

	viewEmail = emailTemplate => {
		Swal.fire({
			allowOutsideClick: false,
			html: `<div id="email-content">${emailTemplate}</div>`,
			width: '60%',
			showConfirmButton: false,
			customClass: { content: 'alert-text' },

			customClass: 'otp_message_success'
		});
	};

	resetFilter = () => {
		const queryItems = qs.parse(window.location.search);
		queryItems.globalSearch = '';
		queryItems.page = 0;
		this.props.history.push({
			search: qs.stringify(queryItems)
		});
		this.setState({
			_customFilterQuery: ''
		});
	};

	render() {
		const columns = [
			{
				name: 'tenant_id',
				label: 'id',
				options: {
					filter: true,
					sort: true,
					display: false
				}
			},
			{
				name: 'template_name',
				label: 'Template Name',
				options: {
					filter: true,
					sort: true
				}
			},
			{
				name: 'key',
				label: 'Key',
				options: {
					filter: true,
					sort: true,
					display: false
				}
			},
			{
				name: 'subject',
				label: 'Subject',
				options: {
					filter: true,
					sort: false
				}
			},
			{
				name: 'locale',
				label: 'locale',
				options: {
					sort: true
				}
			},
			{
				name: 'body',
				label: 'Body',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (value, _obj) => {
						return (
							<VisibilityIcon
								onClick={() => {
									this.viewEmail(value);
								}}
								style={{ cursor: 'pointer', color: 'blue' }}
							/>
						);
					}
				}
			},
			{
				name: 'body',
				label: 'Edit',
				options: {
					customBodyRender: (_value, obj) => {
						const email = {
							body: obj.rowData[5],
							subject: obj.rowData[4],
							locale: obj.rowData[3],
							key: obj.rowData[2]
						};
						return (
							<Link
								to={{
									pathname: `/admin/tenant/update-email-templates/${obj.rowData[0]}/${obj.rowData[2]}/${obj.rowData[4]}`,
									query: email
								}}>
								<EditIcon style={{ cursor: 'pointer', color: 'blue' }} />
							</Link>
						);
					}
				}
			}
		];

		return (
			<>
				<PageHeader text="Email Templates" />
				<Table
					columns={columns}
					customFilterQuery={this.state._customFilterQuery}
					dataSourceHandler={this.getAllEmailTemplates}
					dataSourceName="emails"
					sort
					title={<Filter onResetFilter={this.resetFilter} onSearch={this.searchQuery} />}
				/>
				{this.state._isLoading ? <Loader /> : null}
			</>
		);
	}
}

export default withRouter(hot(module)(EmailTemplates));
